import React from "react"
import ContentLoader from "react-content-loader"

const HomeLoader = (props) => (
  <ContentLoader
    speed={2}
    width={1170}
    height={1000}
    viewBox="0 0 1200 1000"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/* ================= LEFT POST SECTION ================= */}
    {/* Post 1: User Avatar */}
    <circle cx="40" cy="40" r="24" />

    {/* Post 1: User Name & Handle */}
    <rect x="75" y="24" rx="4" ry="4" width="90" height="13" />
    <rect x="75" y="44" rx="4" ry="4" width="75" height="11" />

    {/* Post 1: Date & More Options (dots) */}
    <rect x="620" y="32" rx="3" ry="3" width="70" height="10" />
    <circle cx="710" cy="37" r="2.5" />
    <circle cx="718" cy="37" r="2.5" />
    <circle cx="726" cy="37" r="2.5" />

    {/* Post 1: Description text paragraphs */}
    <rect x="16" y="82" rx="3" ry="3" width="715" height="10" />
    <rect x="16" y="99" rx="3" ry="3" width="715" height="10" />
    <rect x="16" y="116" rx="3" ry="3" width="715" height="10" />
    <rect x="16" y="133" rx="3" ry="3" width="480" height="10" />

    {/* Post 1: Media / Image Box */}
    <rect x="16" y="156" rx="8" ry="8" width="715" height="420" />

    {/* Post 2 (below): User Avatar */}
    <circle cx="40" cy="626" r="24" />
    {/* Post 2: User Name & Handle */}
    <rect x="75" y="610" rx="4" ry="4" width="90" height="13" />
    <rect x="75" y="630" rx="4" ry="4" width="75" height="11" />
    {/* Post 2: Date & More Options */}
    <rect x="620" y="618" rx="3" ry="3" width="70" height="10" />
    <circle cx="710" cy="623" r="2.5" />
    <circle cx="718" cy="623" r="2.5" />
    <circle cx="726" cy="623" r="2.5" />
    {/* Post 2: Description lines */}
    <rect x="16" y="668" rx="3" ry="3" width="715" height="10" />
    <rect x="16" y="685" rx="3" ry="3" width="560" height="10" />
    {/* Post 2: Media Box */}
    <rect x="16" y="708" rx="8" ry="8" width="715" height="260" />

    {/* ================= RIGHT SIDEBAR SECTION ================= */}
    {/* LIVE STREAMS Header & Subtitle */}
    <rect x="780" y="24" rx="4" ry="4" width="130" height="15" />
    <rect x="780" y="47" rx="3" ry="3" width="160" height="10" />

    {/* SUGGESTIONS Header & Navigation Arrows */}
    <rect x="780" y="92" rx="4" ry="4" width="140" height="15" />
    <rect x="1115" y="96" rx="2" ry="2" width="16" height="8" />
    <rect x="1145" y="96" rx="2" ry="2" width="16" height="8" />

    {/* Suggestions Card 1 */}
    <rect x="780" y="125" rx="10" ry="10" width="380" height="110" />

    {/* Suggestions Card 2 */}
    <rect x="780" y="250" rx="10" ry="10" width="380" height="110" />

    {/* Suggestions Card 3 */}
    <rect x="780" y="375" rx="10" ry="10" width="380" height="110" />
  </ContentLoader>
)

export default HomeLoader;
